import { getInitialState, getPath } from "../../utils";

const initialState = {
  countryList: [],
  activeCountry: {},
  prevPage: -1,
  nextPage: -1,
  currentPage: 1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_COUNTRY_LIST":
      return setCountryList(state, action);
    case "SET_ACTIVE_COUNTRY":
      return setActiveCountry(state, action);
    case "RESET_STATE_COUNTRY":
      return resetStateCountry(state, action);
    case "SET_CURRENT_PAGE_COUNTRY":
      return setCurrentPageCountry(state, action);
    default:
      return state;
  }
}

const setCurrentPageCountry = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setCountryList = (state, action) => {
  return {
    ...state,
    countryList: getPath(action.payload, "countries", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const setActiveCountry = (state, action) => {
  return {
    ...state,
    activeCountry: action.payload,
  };
};

const resetStateCountry = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
